<template>
  <div>
    <label class="field_label">{{ current_champ.label }}<span class="text-red"
        v-if="current_champ.mandatory == 1">*</span></label>
    <v-text-field v-model="current_champ.value" @change="verify_input(current_champ)" ref="field"
      @blur="$refs.field.validate()" :disabled="current_champ.disabled || is_disable" :hint="get_hint"
      :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"></v-text-field>
  </div>
</template>

<script>
export default {
  props: ["champ", "inscription", "mode", "is_disable"],
  data() {
    return {
      current_champ: {},
    };
  },
  watch: {
    champ: {
      deep: true,
      handler() {
        this.current_champ = this.champ;
        this.$forceUpdate();
      },
    },
  },
  computed: {
    get_hint() {
      if (this.current_champ.nom == "club") {
        return "Accepté : Majuscules, chiffres, espaces et certains caractères spéciaux";
      }
      return "";
    },
  },
  methods: {
    verify_input(champ) {
      this.verify_change_identity_current_coureur(champ.nom);
      this.reformat_field(champ);
    },
    verify_change_identity_current_coureur(champ) {
      let identity_champs = ["nom", "prenom", "date_naissance", "sexe"];
      if (identity_champs.includes(champ) && this.inscription.coureur.id != null) {
        this.$emit("change_identity_coureur", this.inscription.coureur);
      }
    },
    reformat_field(champ) {
      if (champ.nom == "nom") {
        champ.value = champ.value.toUpperCase();
      }
      if (champ.nom == "club") {
        champ.value = champ.value.toUpperCase();
      }
      if (champ.nom == "prenom") {
        champ.value = champ.value.replace(/(?:^|[\s-])\S/g, (c) => c.toUpperCase());
      }
    },
  },
  created() {
    this.current_champ = this.champ;
  },
};
</script>

<style lang="scss" scoped></style>